import { Doughnut, mixins } from 'vue-chartjs';
// import { hexToRGB } from './utils';

const { reactiveProp } = mixins;//NOTE: So that the chart updates itself when data properties got updated.

export default {
  name: 'doughnut-chart',
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted() {
    this.renderChart(
      this.chartData, {}
    )
  },
  watch: {
    chartData () {
      // console.log('watch', this.chartData);
      this.$data._chart.update()
    }
  }
}